import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';

import Button from 'components/Button';
import DataLoader from 'components/DataLoader';

const ProgramModal = dynamic(() => import('components/modals/ConcertProgram'), {
	loading: DataLoader
});

const ConcertProgram = ({ shortText, annotation }) => {
	const [isOpen, setIsOpen] = useState(false);

	const onClickButton = useCallback(() => {
		setIsOpen(true);
	}, []);

	const onCloseModal = useCallback(() => {
		setIsOpen(false);
	}, []);

	return (
		<div>
			<Button
				title="Программа концерта"
				theme="simple"
				onClick={onClickButton}
			/>
			{isOpen && (
				<ProgramModal
					isOpen={isOpen}
					onClose={onCloseModal}
					shortText={shortText}
					annotation={annotation}
				/>
			)}
		</div>
	);
};

ConcertProgram.propTypes = {
	shortText: PropTypes.string.isRequired,
	annotation: PropTypes.array
};

export default ConcertProgram;
